
import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import Modal from "react-modal";
import * as XLSX from "xlsx";
import "./Custmizemenu.css";
import DEFAULT_IMAGE from "./food.jpg";
import { Link } from "react-router-dom";
import {
    addNewDish, getMenuByVendor, updateCateringDishAPI,
    importCateringMenuAPI,
    addCateringSubcategoryAPI,
    addCateringDishAPI,
    deleteCateringDishAPI,
} from "../../../../Component/Servicefile/Menuapiservice";
Modal.setAppElement("#root");

export default function Cateringcustomizemenu() {
    const [isQuickModal, setIsQuickModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [menu, setMenu] = useState([]);
    const [isVegSelected, setIsVegSelected] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [filteredMenu, setFilteredMenu] = useState([]);
    const [isSaving, setIsSaving] = useState(false);

    const [quickForm, setQuickForm] = useState({
        name: "",
        image: null,
        type: "veg",
    });

    const [isDetailModal, setIsDetailModal] = useState(false);
    const [editRowId, setEditRowId] = useState(null);
    const [detailForm, setDetailForm] = useState({
        name: "",
        category: "",
        price: "",
        quantity: "",
        consumed: "",
        chefType: "",
        type: "veg",
        image: null,
    });
    const [isEditModal, setIsEditModal] = useState(false);
    const [editForm, setEditForm] = useState({
        id: null,
        name: "",
        category: "",
        price: "",
        discount: "",
        description: "",
        type: "veg",
        image: null
    });

    const handleAddClick = (item) => {
        setIsDetailModal(true);
        setEditRowId(item.dishId || item.id);
        setDetailForm({
            name: "",
            category: "",
            price: "",
            discount: "",
            description: "",
            image: null,
            type: "veg"
        });
    };

    const handleEditSave = async () => {
        try {
            const authToken = localStorage.getItem("authToken");
            if (!authToken) throw new Error("No auth token found. Please login.");

            const dishPayload = {
                dishId: editForm.id,
                dishName: editForm.name,
                dishDescription: editForm.description || editForm.category || "",
                dishPrice: Number(editForm.price),
                parentId: editForm.parentId || 0,
                discountPercentage: Number(editForm.discount || 0),
                effectivePrice: Number(editForm.effectivePrice || 0),
                dishType:
                    editForm.type === "veg"
                        ? "Veg"
                        : editForm.type === "nonveg"
                            ? "Non_veg"
                            : "Drinks",
                available: editForm.available ?? true,
            };

            const formData = new FormData();
            formData.append("dishData", new Blob([JSON.stringify(dishPayload)], { type: "application/json" }));

            if (editForm.image instanceof File) {
                formData.append("image", editForm.image);
            }

            const response = await fetch(
                `https://backend.maamaas.com/catering/api/admin/${editForm.id}`,
                {
                    method: "PUT",
                    headers: { Authorization: `Bearer ${authToken}` },
                    body: formData,
                }
            );

            const text = await response.text();

            if (!response.ok) throw new Error(`PUT error! Status: ${response.status} | ${text}`);

            const updatedItem = JSON.parse(text);

            setMenu(prev =>
                prev.map(item =>
                    item.id === updatedItem.dishId
                        ? {
                            ...item,
                            name: updatedItem.dishName,
                            description: updatedItem.dishDescription,
                            price: updatedItem.dishPrice,
                            dishType: updatedItem.dishType,
                            image: updatedItem.dishImage
                                ? updatedItem.dishImage + "?t=" + new Date().getTime()
                                : item.image,
                            discount: updatedItem.discountPercentage,
                            effectivePrice: updatedItem.effectivePrice,
                            available: updatedItem.available,
                        }
                        : item
                )
            );

            setFilteredMenu(prev =>
                prev.map(item =>
                    item.id === updatedItem.dishId
                        ? {
                            ...item,
                            image: updatedItem.dishImage
                                ? updatedItem.dishImage + "?t=" + new Date().getTime()
                                : item.image,
                        }
                        : item
                )
            );

            alert("✅ Item updated successfully!");
            setIsEditModal(false);
            window.location.reload();
        } catch (err) {
            console.error("Failed to update item:", err);
            alert("Failed to update item: " + (err.message || "Unknown error"));
        }
    };

    const handleImport = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const authToken = localStorage.getItem("authToken");
        if (!authToken) {
            alert("No auth token found. Please login again.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await fetch(
                "https://backend.maamaas.com/catering/api/admin/import",
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                        Accept: "*/*",
                    },
                    body: formData,
                }
            );

            const text = await response.text();

            if (!response.ok) {
                throw new Error(`HTTP ${response.status} - ${text}`);
            }

            const result = JSON.parse(text);
            alert("✅ Menu imported successfully from Excel!");

            if (Array.isArray(result)) {
                setMenu((prev) => [...prev, ...result]);
            }

        } catch (error) {
            console.error("🚨 Import failed:", error);
            alert("❌ Import failed: " + (error.message || "Unknown error"));
        } finally {
            event.target.value = "";
        }
    };

    const handleEditChange = (e) => {
        const { name, files, value } = e.target;

        if (name === "image" && files && files[0]) {
            setEditForm(prev => ({ ...prev, image: files[0] }));
        } else {
            setEditForm(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleDetailSave = async () => {
        try {
            setIsSaving(true);

            const authToken = localStorage.getItem("authToken");
            if (!authToken) throw new Error("No auth token found. Please login.");

            const dishData = {
                dishId: 0,
                dishName: detailForm.name || "",
                dishDescription: detailForm.description || detailForm.category || "",
                dishPrice: Number(detailForm.price || 0),
                parentId: editRowId,
                discountPercentage: Number(detailForm.discount || 0),
                effectivePrice:
                    Number(detailForm.price || 0) -
                    (Number(detailForm.price || 0) * Number(detailForm.discount || 0)) / 100,
                available: true,
                dishType:
                    detailForm.type === "veg"
                        ? "Veg"
                        : detailForm.type === "nonveg"
                            ? "Non_veg"
                            : "Drinks",
            };

            const formDataToSend = new FormData();
            formDataToSend.append(
                "dishData",
                new Blob([JSON.stringify(dishData)], { type: "application/json" })
            );

            if (detailForm.image instanceof File) {
                formDataToSend.append("image", detailForm.image);
            }

            const response = await fetch(
                "https://backend.maamaas.com/catering/api/admin/dishes",
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                    body: formDataToSend,
                }
            );

            const text = await response.text();

            if (!response.ok) {
                throw new Error(text);
            }

            const savedDish = JSON.parse(text);
            alert("✅ Subcategory added successfully!");

            setMenu(prev => [
                ...prev,
                { ...detailForm, id: savedDish.dishId, image: detailForm.image },
            ]);

            setDetailForm({
                name: "",
                category: "",
                price: "",
                discount: "",
                description: "",
                image: null,
                type: "veg",
            });
            setIsDetailModal(false);
        } catch (err) {
            console.error("❌ Failed to save subcategory:", err);
            alert("❌ Failed to save subcategory: " + (err.message || "Unknown error"));
        } finally {
            setIsSaving(false);
        }
    };

    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = (error) => reject(error);
        });
    };

    const getValidImageUrl = (url) => {
        if (!url) return DEFAULT_IMAGE;

        try {
            if (url.startsWith("data:image/")) return url;

            let decoded = decodeURIComponent(url);

            if (decoded.startsWith("http://localhost:9000/caterings/http")) {
                const parts = decoded.split("http://localhost:9000/caterings/");
                decoded = `http://localhost:9000/caterings/${parts[parts.length - 1]}`;
            }

            return decoded;
        } catch (err) {
            console.error("Error parsing image URL:", err);
            return DEFAULT_IMAGE;
        }
    };

    const handleDetailChange = (e) => {
        const { name, value, files } = e.target;

        if (name === "image") {
            setDetailForm(prev => ({ ...prev, image: files[0] || null }));
        } else {
            setDetailForm(prev => ({ ...prev, [name]: value }));
        }
    };

    const fetchImageBlob = async (url) => {
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error("Failed to fetch image");
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        } catch (err) {
            console.error(err);
            return DEFAULT_IMAGE;
        }
    };

    useEffect(() => {
        const fetchMenu = async () => {
            setLoading(true);
            setError(null);
            try {
                const data = await getMenuByVendor();

                const formattedMenu = await Promise.all(
                    data.map(async (item) => {
                        let imageUrl = getValidImageUrl(item.dishImage);

                        if (!imageUrl.startsWith("data:image/")) {
                            imageUrl = await fetchImageBlob(imageUrl);
                        }

                        return {
                            id: item.dishId,
                            name: item.dishName,
                            description: item.dishDescription,
                            price: item.dishPrice,
                            parentId: item.parentId,
                            image: imageUrl,
                            discount: item.discountPercentage,
                            effectivePrice: item.effectivePrice,
                            available: item.available,
                            dishType: item.dishType || "-",
                            category: item.category || "-",
                            chefType: item.chefType || "-",
                            gst: item.gst || "-",
                        };
                    })
                );

                setMenu(formattedMenu);
                setFilteredMenu(formattedMenu);
            } catch (err) {
                console.error("Error fetching menu:", err);
                setError("Failed to load menu.");
            } finally {
                setLoading(false);
            }
        };

        fetchMenu();
    }, []);

    useEffect(() => {
        localStorage.setItem("menuData", JSON.stringify(menu));
    }, [menu]);

    const handleQuickSave = async () => {
        if (!quickForm.name) {
            alert("Enter item name!");
            return;
        }

        setIsLoading(true);

        try {
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");

            const dishData = {
                dishName: quickForm.name,
                dishPrice: Number(quickForm.price || 0),
                available: true,
                dishDescription: quickForm.description || "",
            };

            const formDataToSend = new FormData();
            formDataToSend.append(
                "dishData",
                new Blob([JSON.stringify(dishData)], { type: "application/json" })
            );

            if (quickForm.image instanceof File) {
                formDataToSend.append("image", quickForm.image);
            }

            const response = await fetch(
                `https://backend.maamaas.com/catering/api/admin/dishes`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    body: formDataToSend,
                }
            );

            const text = await response.text();

            if (!response.ok) {
                throw new Error(text);
            }

            alert("✅ Dish added successfully!");

            const savedDish = JSON.parse(text);
            setMenu(prev => [
                ...prev,
                {
                    ...quickForm,
                    id: savedDish.dishId,
                    image: quickForm.image,
                    status: true,
                },
            ]);

            setQuickForm({ name: "", price: "", image: null, dishType: "Veg" });
            setIsQuickModal(false);
        } catch (error) {
            console.error("❌ Error adding dish:", error);
            alert(`❌ Failed to add dish: ${error.message}`);
        } finally {
            setIsLoading(false);
        }
    };

    const getBase64WithoutPrefix = (dataUri) => {
        if (!dataUri) return null;
        return dataUri.includes(",") ? dataUri.split(",")[1] : dataUri;
    };

    const handleQuickChange = (e) => {
        const { name, files, value } = e.target;
        if (name === "image" && files && files[0]) {
            setQuickForm(prev => ({ ...prev, image: files[0] }));
        } else {
            setQuickForm(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this item?")) return;

        try {
            setIsSaving(true);

            const authToken = localStorage.getItem("authToken");
            if (!authToken) throw new Error("No auth token found. Please login.");

            const response = await fetch(
                `https://backend.maamaas.com/catering/api/admin/delete/${id}`,
                {
                    method: "DELETE",
                    headers: {
                        "Accept": "*/*",
                        Authorization: `Bearer ${authToken}`
                    }
                }
            );

            if (!response.ok) {
                const text = await response.text();
                throw new Error(`DELETE error! Status: ${response.status} | ${text}`);
            }

            alert("Item deleted successfully!");

            setMenu(prev => prev.filter(item => item.id !== id));
            setFilteredMenu(prev => prev.filter(item => item.id !== id));
        } catch (err) {
            console.error("Failed to delete item:", err);
            alert("Failed to delete item: " + (err.message || "Unknown error"));
        } finally {
            setIsSaving(false);
        }
    };

    const handleEdit = (item) => {
        setEditForm({
            id: item.id,
            name: item.name || "",
            category: item.category || "",
            price: item.price || "",
            discount: item.discount || "",
            description: item.description || "",
            image: item.image || null,
            type: item.dishType === "Veg" ? "veg" : item.dishType === "Non_veg" ? "nonveg" : "drinks",
        });
        setIsEditModal(true);
    };

    const handleExport = () => {
        const ws = XLSX.utils.json_to_sheet(menu);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Menu");
        XLSX.writeFile(wb, "menu.xlsx");
    };

    const handleFilterClick = (type) => {
        if (type === "Veg") {
            // Only show subcategories that are Veg, but always show main categories
            const mainCategories = menu.filter(item => !item.parentId);
            const vegSubcategories = menu.filter(item =>
                item.parentId &&
                item.dishType?.toLowerCase() === "veg"
            );

            // Combine main categories with their matching veg subcategories
            const filtered = [];
            mainCategories.forEach(mainCat => {
                filtered.push(mainCat);
                const matchingSubs = vegSubcategories.filter(sub => sub.parentId === mainCat.id);
                filtered.push(...matchingSubs);
            });

            setFilteredMenu(filtered);
            setIsVegSelected("veg");
        } else if (type === "Non-Veg") {
            // Only show subcategories that are Non-Veg, but always show main categories
            const mainCategories = menu.filter(item => !item.parentId);
            const nonVegSubcategories = menu.filter(item =>
                item.parentId &&
                (item.dishType?.toLowerCase() === "non-veg" ||
                    item.dishType?.toLowerCase() === "nonveg" ||
                    item.dishType?.toLowerCase() === "non_veg")
            );

            // Combine main categories with their matching non-veg subcategories
            const filtered = [];
            mainCategories.forEach(mainCat => {
                filtered.push(mainCat);
                const matchingSubs = nonVegSubcategories.filter(sub => sub.parentId === mainCat.id);
                filtered.push(...matchingSubs);
            });

            setFilteredMenu(filtered);
            setIsVegSelected("nonveg");
        } else if (type === "Drinks") {
            // Only show subcategories that are Drinks, but always show main categories
            const mainCategories = menu.filter(item => !item.parentId);
            const drinksSubcategories = menu.filter(item =>
                item.parentId &&
                item.dishType?.toLowerCase() === "drinks"
            );

            // Combine main categories with their matching drinks subcategories
            const filtered = [];
            mainCategories.forEach(mainCat => {
                filtered.push(mainCat);
                const matchingSubs = drinksSubcategories.filter(sub => sub.parentId === mainCat.id);
                filtered.push(...matchingSubs);
            });

            setFilteredMenu(filtered);
            setIsVegSelected("drinks");
        } else {
            // Show all items
            setFilteredMenu(menu);
            setIsVegSelected(null);
        }
    };

    // Helper function to get button text and color based on current filter
    const getFilterButtonText = () => {
        if (isVegSelected === null) return "Type";
        if (isVegSelected === "veg") return "Veg";
        if (isVegSelected === "nonveg") return "Non-Veg";
        if (isVegSelected === "drinks") return "Drinks";
        return "Type";
    };

    const getFilterButtonColor = () => {
        if (isVegSelected === null) return "#888";
        if (isVegSelected === "veg") return "green";
        if (isVegSelected === "nonveg") return "red";
        if (isVegSelected === "drinks") return "blue";
        return "#888";
    };

    // Helper function to cycle through filter options
    const getNextFilterType = () => {
        if (isVegSelected === null) return "Veg";
        if (isVegSelected === "veg") return "Non-Veg";
        if (isVegSelected === "nonveg") return "Drinks";
        if (isVegSelected === "drinks") return "All";
        return "Veg";
    };

    return (
        <div className="container-fluid" style={{ marginTop: "120px" }}>
            <div className="row">
                {/* <div className="col-lg-2"></div> */}
                <div className="col-lg-12">
                    <div className="menu-container">


                        <div className="top-bar">
                            <div className="left-side">
                                <button className="add-btn" onClick={() => setIsQuickModal(true)}>
                                    <FaPlus /> Add Item
                                </button>
                            </div>
                            <div className="menu-right-side">
                                <button className="menu-export-btn" onClick={handleExport}>Export</button>
                                <label className="menu-import-btn">
                                    Import
                                    <input type="file" hidden onChange={handleImport} />
                                </label>
                            </div>
                        </div>

                        <div className="table-wrapper" style={{
                            marginTop: "30px",
                            height: "500px",
                            overflow: "auto",
                            position: "relative"
                        }}>
                            <table className="menu-table" style={{ width: "100%", tableLayout: "fixed" }}>
                                <thead style={{
                                    position: "sticky",
                                    top: "0",
                                    backgroundColor: "#f8f9fa",
                                    zIndex: "10",
                                    boxShadow: "0 2px 2px -1px rgba(0,0,0,0.1)"
                                }}>
                                    <tr>
                                        <th style={{ width: "5%" }}>S.No</th>
                                        <th style={{ width: "20%" }}>Category</th>
                                        <th style={{ width: "10%" }}>Image</th>
                                        <th style={{ width: "15%" }}>
                                            <div
                                                onClick={() => handleFilterClick(getNextFilterType())}
                                                className="veg-toggle"
                                                style={{
                                                    backgroundColor: getFilterButtonColor(),
                                                    color: "#fff",
                                                    padding: "6px 12px",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    display: "inline-block",
                                                    minWidth: "80px",
                                                    minHeight: "30px",
                                                    textAlign: "center",
                                                    whiteSpace: "nowrap",
                                                    fontSize: "14px"
                                                }}
                                            >
                                                {getFilterButtonText()}
                                            </div>
                                        </th>
                                        <th style={{ width: "10%" }}>Price</th>
                                        <th style={{ width: "10%" }}>Discount</th>
                                        <th style={{ width: "20%" }}>Description</th>
                                        <th style={{ width: "10%" }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredMenu
                                        .filter(item => !item.parentId)
                                        .map((item, index) => (
                                            <React.Fragment key={item.id}>
                                                {/* Main Category Row */}
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td>{item.name}</td>
                                                    <td>
                                                        <img
                                                            src={getValidImageUrl(item.image)}
                                                            alt={item.name}
                                                            className="item-img"
                                                            style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                                        />
                                                    </td>
                                                    <td>{item.dishType}</td>
                                                    <td>-</td>
                                                    <td>-</td>
                                                    <td>{item.description}</td>
                                                    <td>
                                                        <button className="row-add-btn" onClick={() => handleAddClick(item)}>Add</button>
                                                        <FaEdit className="action-icon edit" onClick={() => handleEdit(item)} />
                                                        <FaTrash className="action-icon delete" onClick={() => handleDelete(item.id)} />
                                                    </td>
                                                </tr>

                                                {/* Subcategory Rows - Filtered by Veg/Non-Veg/Drinks */}
                                                {filteredMenu
                                                    .filter(sub => sub.parentId === item.id)
                                                    .map((subItem, subIndex) => (
                                                        <tr key={subItem.id} style={{ backgroundColor: "#f9f9f9" }}>
                                                            {/* Display subcategory serial number as index+1.subIndex+1 */}
                                                            <td>{index + 1}.{subIndex + 1}</td>
                                                            <td style={{ paddingLeft: "30px" }}>↳ {subItem.name}</td>
                                                            <td>
                                                                <img
                                                                    src={getValidImageUrl(subItem.image)}
                                                                    alt={subItem.name}
                                                                    className="item-img"
                                                                    style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                                                />
                                                            </td>
                                                            <td>{subItem.dishType}</td>
                                                            <td>₹{subItem.price}</td>
                                                            <td>{subItem.discount}%</td>
                                                            <td>{subItem.description}</td>
                                                            <td>
                                                                <FaEdit className="action-icon edit" onClick={() => handleEdit(subItem)} />
                                                                <FaTrash className="action-icon delete" onClick={() => handleDelete(subItem.id)} />
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </React.Fragment>
                                        ))}

                                    {/* Show message if no main categories have matching subcategories when filter is active */}
                                    {isVegSelected !== null &&
                                        filteredMenu.filter(item => !item.parentId).length === 0 && (
                                            <tr>
                                                <td colSpan="8" style={{ textAlign: "center", padding: "20px" }}>
                                                    No {
                                                        isVegSelected === "veg" ? "Veg" :
                                                            isVegSelected === "nonveg" ? "Non-Veg" :
                                                                isVegSelected === "drinks" ? "Drinks" : ""
                                                    } subcategories found.
                                                </td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>
                        </div>

                        <Modal
                            isOpen={isEditModal}
                            onRequestClose={() => setIsEditModal(false)}
                            className="detail-modal-content"
                            overlayClassName="modal-overlay"
                        >
                            <h3>Edit Item</h3>
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Item Name"
                                    value={editForm.name}
                                    onChange={handleEditChange}
                                />
                                <input
                                    type="text"
                                    name="category"
                                    placeholder="Category"
                                    value={editForm.category}
                                    onChange={handleEditChange}
                                />
                                <input
                                    type="number"
                                    name="price"
                                    placeholder="Price"
                                    value={editForm.price}
                                    onChange={handleEditChange}
                                />
                                <input
                                    type="number"
                                    name="discount"
                                    placeholder="Discount %"
                                    value={editForm.discount}
                                    onChange={handleEditChange}
                                />
                                <input
                                    type="text"
                                    name="description"
                                    placeholder="Description"
                                    value={editForm.description}
                                    onChange={handleEditChange}
                                />
                                {editForm.image && !(editForm.image instanceof File) && (
                                    <img
                                        src={getValidImageUrl(editForm.image)}
                                        alt="Current"
                                        style={{ width: "100px", height: "100px", objectFit: "cover", marginBottom: "10px" }}
                                    />
                                )}
                                <input type="file" name="image" onChange={handleEditChange} />
                                <select name="type" value={editForm.type} onChange={handleEditChange}>
                                    <option value="veg">Veg</option>
                                    <option value="nonveg">Non-Veg</option>
                                    <option value="drinks">Drinks</option>
                                </select>
                            </div>
                            <div className="modal-actions">
                                <button className="cancel-btn" onClick={() => setIsEditModal(false)}>Cancel</button>
                                <button className="save-btn" onClick={handleEditSave}>Save</button>
                            </div>
                        </Modal>

                        <Modal
                            isOpen={isQuickModal}
                            onRequestClose={() => setIsQuickModal(false)}
                            className="quick-modal-content"
                            overlayClassName="modal-overlay"
                            style={{
                                overlay: {
                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                    zIndex: 10000,
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                },
                                content: {
                                    position: 'relative',
                                    margin: 'auto',
                                    border: '1px solid #ccc',
                                    background: '#fff',
                                    overflow: 'auto',
                                    WebkitOverflowScrolling: 'touch',
                                    borderRadius: '4px',
                                    outline: 'none',
                                    padding: '20px',
                                    maxWidth: '500px',
                                    width: '90%',
                                    zIndex: 10001
                                }
                            }}
                        >
                            <h3>Add Category</h3>
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Item Name"
                                    value={quickForm.name}
                                    onChange={handleQuickChange}
                                />
                                <input type="file" name="image" onChange={handleQuickChange} />
                            </div>
                            <div className="modal-actions">
                                <button className="cancel-btn" onClick={() => setIsQuickModal(false)}>
                                    Cancel
                                </button>
                                <button className="save-btn" onClick={handleQuickSave} disabled={isLoading}>
                                    {isLoading ? "Adding..." : "Add"}
                                </button>
                            </div>
                        </Modal>

                        <Modal
                            isOpen={isDetailModal}
                            onRequestClose={() => setIsDetailModal(false)}
                            className="detail-modal-content"
                            overlayClassName="modal-overlay"
                            style={{
                                overlay: {
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                    zIndex: 10000
                                },
                                content: {
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    background: 'white',
                                    padding: '20px',
                                    borderRadius: '8px',
                                    maxWidth: '500px',
                                    width: '90%',
                                    zIndex: 10001
                                }
                            }}
                        >
                            <h3>{editRowId ? "Add Subcategory" : "Add Details"}</h3>
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="parentId"
                                    placeholder="Parent Dish ID"
                                    value={editRowId || ""}
                                    readOnly
                                />
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Item Name"
                                    value={detailForm.name}
                                    onChange={handleDetailChange}
                                />
                                <input
                                    type="number"
                                    name="price"
                                    placeholder="Price"
                                    value={detailForm.price}
                                    onChange={handleDetailChange}
                                />
                                <input
                                    type="number"
                                    name="discount"
                                    placeholder="Discount %"
                                    value={detailForm.discount}
                                    onChange={handleDetailChange}
                                />
                                <input
                                    type="text"
                                    name="description"
                                    placeholder="Description"
                                    value={detailForm.description}
                                    onChange={handleDetailChange}
                                />
                                <input type="file" name="image" onChange={handleDetailChange} />
                                <select name="type" value={detailForm.type} onChange={handleDetailChange}>
                                    <option value="veg">Veg</option>
                                    <option value="nonveg">Non-Veg</option>
                                    <option value="drinks">Drinks</option>
                                </select>
                            </div>
                            <div className="modal-actions">
                                <button className="cancel-btn" onClick={() => setIsDetailModal(false)}>Cancel</button>
                                <button
                                    className="save-btn"
                                    onClick={handleDetailSave}
                                    disabled={isSaving}
                                >
                                    {isSaving ? "Saving..." : "Save"}
                                </button>
                            </div>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    );
}